const input = {
    username: 'Uživatelské jméno',
    password: 'Heslo',
    email: 'E-mailová adresa',
    phone_number: 'Telefonní číslo',
    student_number: 'Studentské číslo',
    registration_number: 'Registrační číslo',
    student_identifier_legend: 'Přihlásit se pomocí',
    confirm_password: 'Potvrď heslo',
    search_region_code: 'Hledat telefonní předvolbu',
    backup_code: 'Záložní kód',
    code: 'Kód',
    label_with_optional: '{{label}} (Volitelné)',
};
export default Object.freeze(input);
